import {makeStyles} from "@material-ui/core";
import {ERROR_BACKGROUND, ERROR_COLOR} from "../../themes/themeConfigurator";

export default makeStyles((theme) => ({
  dialogTitle: {
    background: ERROR_BACKGROUND,
    '& .fa-exclamation-triangle': {
      color: ERROR_COLOR,
      marginRight: theme.spacing(1)
    }
  },
  messageContent: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  buttonCancel: {
    color: theme.palette.secondary.main,
    border: '1px solid',
    borderColor: theme.palette.secondary.main,
    '&:hover': {
      borderColor: theme.palette.secondary.dark,
      backgroundColor: 'rgba(229, 0, 0, 0.04)',
    },
  }
}))